module.exports = __webpack_public_path__ + "static/media/LBBox.8c8e35b9.png";